import {
    types
} from '../actions/types';

const DEFAULT_STATE = {
    clientData: null //{
    // provider: null,
    // services: null,
    // bookings: null,
    // clients: null,
    // purchases: null,
    // uid: null,
    // firstName: null,
    // lastName: null,
    // profilePhotoURL: null,
    // email: null,
    // SBMClientId: null,
    // credits: null,
    // serviceProviders: null,
    // messageThreads: null
    //}
};

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {

        // RECEIVE USER CLIENT DATA
        case types.GET_CLIENT_DATA_SUCCESS:
            return {
                ...state,
                clientData: action.payload
            }
        case types.LOG_OUT_SUCCESS:
            return {
                ...DEFAULT_STATE
            }
        case types.RESET_CLIENT_DATA:
            return {
                ...DEFAULT_STATE
            }
        case types.GET_CLIENT_DATA_FAIL:
            return {
                ...state,
                clientData: action.payload,
                error: 'Could not get client data'
            }
        case types.CREDITS_PAYMENT_SUCCESS:
            return {
                ...state,
                clientData: { ...state.clientData,
                    credits: action.payload
                }
            }
        case types.CREDITS_PAYMENT_FAIL:
            return {
                ...state,
                clientData: { ...state.clientData,
                    credits: action.payload
                }
            }
        case types.GET_ALL_CLIENT_BOOKINGS:
            return {
                ...state,
                clientData: { ...state.clientData,
                    bookings: action.payload
                }
            }
        case types.GET_FUTURE_CLIENT_BOOKINGS:
            return {
                ...state,
                clientData: { ...state.clientData,
                    futureBookings: action.payload
                }
            }
        case types.GET_PAST_CLIENT_BOOKINGS:
            return {
                ...state,
                clientData: { ...state.clientData,
                    pastBookings: action.payload
                }
            }
        case types.GET_USER_ACTIVITY_STATUS_SUCCESS:
            return {
                ...state,
                clientData: { ...state.clientData,
                    idleStatus: action.payload
                }
            }
        case types.GET_USER_ACTIVITY_STATUS_FAIL:
            return {
                ...state,
                clientData: { ...state.clientData,
                    idleStatus: action.payload
                }
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/client-reducer.js